import {Navigate, Route, Routes} from 'react-router-dom';

import {AppShell} from '../components/AppShell.js';
import {EntryPage} from '../pages/EntryPage.js';
import {LeadConversationPage} from '../pages/LeadConversationPage.js';
import {PrivacyRequestsPage} from '../pages/PrivacyRequestsPage.js';
import {usePanel} from './PanelProvider.js';
import {PANEL_ROUTES, type PanelRoute} from './routes.js';

/**
 * Moldura de página: o bloco de título que a prévia aprovada repete nas quatro
 * páginas. Fica aqui, e não copiado em cada página, para o título não divergir
 * entre elas.
 */
const PanelPage = ({route}: {route: PanelRoute}) => {
  const {snapshot} = usePanel();
  if (!snapshot) {
    return null;
  }
  const {Body} = route;

  return (
    <section data-page={route.id}>
      <div className="dm-page-title">
        <div>
          <h1>{route.title}</h1>
          <p className="dm-subtitle">{route.subtitle(snapshot)}</p>
        </div>
        <span className="dm-illustrative">{route.badge(snapshot)}</span>
      </div>
      {Body ? <Body /> : null}
    </section>
  );
};

export const PanelRouter = () => (
  <Routes>
    {/*
      A tela de entrada vive FORA do AppShell: ela não tem sidebar nem topbar,
      e não depende de snapshot. No modo fixture ela nem chega a renderizar:
      sem porta de autenticação, as duas rotas devolvem para /hoje, que é o
      que a rota desconhecida já fazia antes de a tela existir.
    */}
    <Route path="/entrar" element={<EntryPage mode="login" />} />
    <Route path="/entrar/cadastro" element={<EntryPage mode="bootstrap" />} />
    <Route element={<AppShell />}>
      {PANEL_ROUTES.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<PanelPage route={route} />}
        />
      ))}
      {/*
        As duas telas que a prévia aprovada não cobre.

        Elas ficam FORA de `PANEL_ROUTES` de propósito: aquela tabela também
        alimenta a navegação da esquerda, e cada item novo lá mexe na faixa de
        menu das quatro telas travadas por comparação de pixel. Quem entra ali
        paga o recongelamento do baseline, que é o preço que o radar paga;
        estas duas não valem esse preço. Aqui elas existem como rota, e chega-se
        a elas pela URL e pelo clique (a referência da conversa, na tabela do
        MAPA, e o atalho no detalhe da conversa).
      */}
      <Route path="/mapa/:pseudonym" element={<LeadConversationPage />} />
      <Route path="/privacidade" element={<PrivacyRequestsPage />} />
      <Route path="*" element={<Navigate to="/hoje" replace />} />
    </Route>
  </Routes>
);
